import { hextoRgba } from "@/main/services/utils";
import styled from "styled-components";

export const Overlay = styled.div`
	position: fixed;
	top: 0;
	right: 0;
	width: 100%;
`;

export const Container = styled.div`
	position: relative;
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	align-items: center;
	gap: 1rem;
	padding: 5rem 1rem 0;
	height: 100%;
	overflow: auto;
	width: 100%;
	max-width: 300px;
	min-width: 300px;
	background: ${({ theme }) => hextoRgba(theme.pantone657C, 0.9)};
	margin-left: auto;
	box-shadow: 0px 0px 10px 0px ${({ theme }) => hextoRgba(theme.pantone657C, 0.8)};
`;

export const SubPage = styled.div`
	color: ${({ theme }) => theme.white};

	:hover {
		filter: brightness(0.5);
	}
`;

export const AreaLogo = styled.div`
	position: absolute;
	top: 1rem;
	left: 1rem;
`;
export const Logo = styled.img`
	width: 100%;
	max-width: 120px;
`;

export const AreaCloseIcon = styled.div`
	position: absolute;
	top: 1.4rem;
	right: 1rem;

	svg {
		color: ${({ theme }) => theme.white};
	}
`;
